<template>
	<div v-if="report">
		<div class="bill-audit-report-page">
			<b-row>
				<b-col>
					<table class="table">
						<thead>
							<tr>
								<th colspan="2">Anagrafica cliente</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>Ragione sociale</th>
								<td>{{ report.customerData.businessName }}</td>
							</tr>
							<tr>
								<th>Partita IVA</th>
								<td>{{ report.customerData.taxCode }}</td>
							</tr>
							<tr>
								<th>Classe</th>
								<td>{{ report.customerData.customerClass }}</td>
							</tr>
						</tbody>
					</table>
				</b-col>
				<b-col>
					<table class="table">
						<thead>
							<tr>
								<th colspan="4">Punto di prelievo</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<th>Località di fornitura</th>
								<td colspan="2">{{ report.siteData.address }}</td>
							</tr>
							<tr>
								<th>Fornitore</th>
								<td>{{ report.siteData.supplier }}</td>
								<th>Pot. disponibile [kW]</th>
								<td>{{ report.siteData.availability }}</td>
							</tr>
							<tr>
								<th>Codice POD</th>
								<td>{{ report.siteData.pod }}</td>
								<th>Opzione tariffaria</th>
								<td>{{ report.siteData.tariffOption }}</td>
							</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<table class="table">
						<tr>
							<th class="head">Consumi</th>
							<th class="head" v-for="(item, index) in consumption" :key="index">{{ item.month }}</th>
							<th class="head" colspan="2">Totale [kWh]</th>
						</tr>
						<!-- Consumi -->
						<tr>
							<th>Consumo energia [kWh]</th>
							<td v-for="(item, index) in consumption" :key="index">{{ item.value }}</td>
							<td rowspan="2" colspan="2" class="all-center bold">{{ totalConsumption.value }}</td>
						</tr>
						<tr>
							<th>Potenza massima [kW]</th>
							<td v-for="(item, index) in power" :key="index">{{ item.value }}</td>
						</tr>
						<tr>
							<td :colspan="monthCount + 3">&nbsp;</td>
						</tr>

						<!-- Importi calcolati -->
						<tr>
							<th class="head">Importi calcolati</th>
							<th class="head" v-for="(item, index) in consumption" :key="index">{{ item.month }}</th>
							<th class="head">[€]</th>
							<th class="head">[€/MWh]</th>
						</tr>
						<tr>
							<th>Energia [€]</th>
							<td v-for="(item, index) in energyAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('energyAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('energyAmount').value }}</td>
						</tr>
						<tr>
							<th>Dispacciamento [€]</th>
							<td v-for="(item, index) in dispatchmentAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('dispatchmentAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('dispatchmentAmount').value }}</td>
						</tr>
						<tr>
							<th>Spesa trasporto e gestione contatore [€]</th>
							<td v-for="(item, index) in transportAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('transportAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('transportAmount').value }}</td>
						</tr>
						<tr>
							<th>Imposte [€]</th>
							<td v-for="(item, index) in taxAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('taxAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('taxAmount').value }}</td>
						</tr>
						<tr>
							<th>Energia reattiva [€]</th>
							<td v-for="(item, index) in reaEnergyAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('reaEnergyAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('reaEnergyAmount').value }}</td>
						</tr>
						<tr>
							<th>Totale [€]</th>
							<td class="bold" v-for="(item, index) in totalAmount" :key="index">{{ item.value }}</td>
							<td class="bold">{{ totalReportAmount.value }}</td>
							<td class="bold">{{ getTotalExpenseConsumptionRatio().value }}</td>
						</tr>
						<tr>
							<th>Unitario [€/MWh]</th>
							<td class="bold" v-for="(item, index) in unitary" :key="index">{{ item }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td :colspan="monthCount + 3">&nbsp;</td>
						</tr>

						<!-- Importi fatturati 	-->
						<tr>
							<th class="head">Importi fatturati [€]</th>
							<th class="head" v-for="(item, index) in consumption" :key="index">{{ item.month }}</th>
							<th class="head">[€]</th>
							<th class="head">[€/MWh]</th>
						</tr>
						<tr>
							<th>Energia [€]</th>
							<td v-for="(item, index) in energyInvoiceAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('energyInvoiceAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('energyInvoiceAmount').value }}</td>
						</tr>
						<tr>
							<th>Dispacciamento [€]</th>
							<td v-for="(item, index) in dispatchmentInvoiceAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('dispatchmentInvoiceAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('dispatchmentInvoiceAmount').value }}</td>
						</tr>
						<tr>
							<th>Spesa trasporto e gestione contatore [€]</th>
							<td v-for="(item, index) in transportInvoiceAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('transportInvoiceAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('transportInvoiceAmount').value }}</td>
						</tr>
						<tr>
							<th>Imposte [€]</th>
							<td v-for="(item, index) in taxInvoiceAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('taxInvoiceAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('taxInvoiceAmount').value }}</td>
						</tr>
						<tr>
							<th>Energia reattiva [€]</th>
							<td v-for="(item, index) in reaEnergyInvoiceAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('reaEnergyInvoiceAmount').value }}</td>
							<td>{{ getExpenseConsumptionRatio('reaEnergyInvoiceAmount').value }}</td>
						</tr>
						<tr>
							<th>Totale [€]</th>
							<td class="bold" v-for="(item, index) in totalInvoiceAmount" :key="index">{{ item.value }}
							</td>
							<td class="bold">{{ grandTotalInvoice.value }}</td>
							<td class="bold">{{ getTotalInvoiceExpenseConsumptionRatio().value }}</td>
						</tr>
						<tr>
							<th>Unitario [€/MWh]</th>
							<td class="bold" v-for="(item, index) in unitaryInvoice" :key="index">{{ item }}</td>
							<td></td>
							<td></td>
						</tr>
						<tr>
							<td :colspan="monthCount + 3">&nbsp;</td>
						</tr>

						<!-- Bonus -->
						<tr>
							<th class="head">Imprese energivore DM 21.12.17</th>
							<th class="head" v-for="(item, index) in consumption" :key="index">{{ item.month }}</th>
							<th class="head">[€]</th>
							<th class="head">[€/MWh]</th>
						</tr>
						<tr>
							<th>Beneficio mensile [€]</th>
							<td v-for="(item, index) in bonusAmount" :key="index">{{ item.value }}</td>
							<td>{{ getTotal('bonusAmount').value }}</td>
							<td></td>
						</tr>
					</table>
				</b-col>
			</b-row>
		</div>
		<div class="bill-audit-report-page">
			<b-row>
				<b-col>
					<ConguaglioTable :calculatedTotal="totalReportAmount.raw" :invoiceTotal="grandTotalInvoice.raw" />
				</b-col>
				<b-col>
					<PrelieviTable :data="report.yearlyConsumptions" :year="year" />
				</b-col>
				<b-col cols="6">
					<CostsTable :data="report.yearlyCosts" :consumption="report.yearlyConsumptions" :year="year" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<ConsumptionChart :data="report.monthlyConsumptions" />
				</b-col>
			</b-row>
			<div class="d-flex">
				<div style="width: 33%">
					<CosPhiLineChart :data="report.monthlyCosPhi" />
				</div>
				<div style="width: 33%">
					<PowerLineChart :data="report.monthlyPower" />
				</div>
				<div style="width: 33%">
					<YearlySlotsChart :data="report.yearlySlots" />
				</div>
			</div>
		</div>
		<div class="bill-audit-report-page">
			<b-row>
				<b-col>
					<HourlyConsumption :data="report.dayHourConsumptionAverage" />
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<SupplyAndSelfProdChart :data="report.supplyAndSelfProduction" />
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import moment from 'moment';
import utils from '../../utilsMixin';
import ConguaglioTable from './Tables/ConguaglioTable.vue';
import PrelieviTable from './Tables/PrelieviTable.vue';
import CostsTable from './Tables/CostsTable.vue';
import ConsumptionChart from './Charts/ConsumptionChart.vue';
import CosPhiLineChart from './Charts/CosPhiLineChart.vue';
import PowerLineChart from './Charts/PowerLineChart.vue';
import YearlySlotsChart from './Charts/YearlySlotsChart.vue';
import HourlyConsumption from './Charts/HourlyConsumption.vue';
import SupplyAndSelfProdChart from './Charts/SupplyAndSelfProdChart.vue';

import '@/assets/css/bill-audit-print.css';

export default {
	name: "BillAuditReport",
	mixins: [utils],
	components: {
		ConguaglioTable, PrelieviTable, CostsTable, ConsumptionChart,
		CosPhiLineChart, PowerLineChart, YearlySlotsChart, HourlyConsumption,
		SupplyAndSelfProdChart
	},
	data() {
		return {
			report: null
		}
	},
	async created() {
		this.$store.commit("loading")
		try {
			const response = await this.$store.dispatch('billaudit/getReport', this.$route.params.id)
			if(response.code != 1) {
				throw new Error(response.message)
			}
			this.report = response.data
			this.report.consumption.sort((a, b) => a.timeCode - b.timeCode)
			this.$store.commit("stopLoading")
		} catch (e) {
			console.log(e)
			this.$notify({
				type: "error",
				text: e.message,
				title: 'Errore',
			});
			this.$store.commit("stopLoading")
		}
	},
	methods: {
		getData(name) { 
			console.log(`getData ${name}`)
			if(! this.report || ! this.report[name]) {
				return [].fill({}, this.monthCount)
			}
			const data = []
			const startingMonth = moment(this.report.from, 'YYYYMM')
			for (let i = 0; i < this.monthCount; i++) {
				const currentMonth = moment(startingMonth).add(i, 'months')
				const item = this.report[name].find(item => item.timeCode == currentMonth.format('YYYYMM'))	
				if(! item) {
					data.push({
						month: `${currentMonth.format('MMM')} ${currentMonth.format('YY')}`,
						value: 0,
					})
					continue
				}
				data.push({
					month: `${currentMonth.format('MMM')} ${currentMonth.format('YY')}`,
					value: this.formatPrecision(item.value, 0),
					raw: item.value || 0
				})
				
			}
			return data
		},		
		getTotal(name) {
			if(! this.report || ! this.report[name]) {
				return {}
			}
			const total = this.report[name].reduce((acc, item) => acc + item.value, 0)
			return {
				value: this.formatPrecision(total, 0),
				raw: total
			}
		},
		getExpenseConsumptionRatio(name) {
			if(! this.report || ! this.report[name]) {
				return {}
			}
			const total = this.getTotal(name).raw
			const consumption = this.totalConsumption.raw
			if(consumption == 0) {
				return {
					value: 0,
					raw: 0
				}
			}
			const ratio = total / (consumption / 1000)
			return {
				value: this.formatPrecision(ratio, 0), 
				raw: ratio
			}
		},
		getTotalExpenseConsumptionRatio() {
			if (!this.report) {
				return {}
			}
			const total = this.totalReportAmount.raw
			const consumption = this.totalConsumption.raw
			if (consumption == 0) {
				return {
					value: 0,
					raw: 0
				}
			}
			const ratio = total / (consumption / 1000)
			return {
				value: this.formatPrecision(ratio, 0),
				raw: ratio
			}
		},
		getTotalInvoiceExpenseConsumptionRatio() {
			if (!this.report) {
				return {}
			}
			const total = this.grandTotalInvoice.raw
			const consumption = this.totalConsumption.raw
			if (consumption == 0) {
				return {
					value: 0,
					raw: 0
				}
			}
			const ratio = total / (consumption / 1000)
			return {
				value: this.formatPrecision(ratio, 0),
				raw: ratio
			}
		},
	},
	computed: {
		year() {
			return Math.floor(this.report.from / 100)
		},
		consumption() {
			return this.getData('consumption')
		},
		totalConsumption() {
			const value = this.consumption.reduce((acc, curr) => acc + curr.raw, 0)
			return {
				value: this.formatPrecision(value, 0),
				raw: value
			}
		},
		power() {
			return this.getData('power')
		},
		energyAmount() {
			return this.getData('energyAmount')
		},
		reaEnergyAmount() {
			return this.getData('reaEnergyAmount')
		},
		transportAmount() {
			return this.getData('transportAmount')
		},
		dispatchmentAmount() {
			return this.getData('dispatchmentAmount')
		},
		taxAmount() {
			return this.getData('taxAmount')
		},
		energyInvoiceAmount() {
			return this.getData('energyInvoiceAmount')
		},
		reaEnergyInvoiceAmount() {
			return this.getData('reaEnergyInvoiceAmount')
		},
		transportInvoiceAmount() {
			return this.getData('transportInvoiceAmount')
		},
		dispatchmentInvoiceAmount() {
			return this.getData('dispatchmentInvoiceAmount')
		},
		taxInvoiceAmount() {
			return this.getData('taxInvoiceAmount')
		},
		bonusAmount() {
			return this.getData('bonusAmount')
		},
		totalAmount() {
			const data = []
			for (let i = 0; i < this.monthCount; i++) {
				const total =
					(this.energyAmount[i].raw || 0) +
					(this.dispatchmentAmount[i].raw || 0) +
					(this.transportAmount[i].raw || 0) +
					(this.taxAmount[i].raw || 0) +
					(this.reaEnergyAmount[i].raw || 0)					
				data.push({
					value: this.formatPrecision(total, 0),
					raw: total
					
				})
			}
			return data
		},
		totalReportAmount() {
			const value = this.totalAmount.reduce((acc, curr) => acc + curr.raw, 0)
			return {
				value: this.formatPrecision(value, 0),
				raw: value
			}
		},
		totalInvoiceAmount() {
			const data = []
			for (let i = 0; i < this.monthCount; i++) {
				const total =
					(this.energyInvoiceAmount[i].raw || 0) +
					(this.dispatchmentInvoiceAmount[i].raw || 0) +
					(this.transportInvoiceAmount[i].raw || 0) +
					(this.taxInvoiceAmount[i].raw || 0) +
					(this.reaEnergyInvoiceAmount[i].raw || 0)					
				data.push({
					value: this.formatPrecision(total, 0),
					raw: total
					
				})
			}
			return data
		},
		unitary() {
			const data = []
			for (let i = 0; i < this.monthCount; i++) {
				if (!this.consumption[i].raw) {
					data.push(0)
					continue
				}
				data.push(
					this.formatPrecision(
					this.totalAmount[i].raw / this.consumption[i].raw / 1000, 2)
				)
			}
			return data
		},	
		unitaryInvoice() {
			const data = []
			for (let i = 0; i < this.monthCount; i++) {
				if (!this.consumption[i].raw) {
					data.push(0)
					continue
				}
				data.push(
					this.formatPrecision(
					this.totalInvoiceAmount[i].raw / this.consumption[i].raw / 1000, 2)
				)
			}
			return data
		},
		totalUnitary() {
			return this.totalReportAmount / this.totalConsumption.raw / 1000
		},
		grandTotalInvoice() {
			const value = this.totalInvoiceAmount.reduce((acc, curr) => acc + curr.raw, 0)
			return {
				value: this.formatPrecision(value, 0),
				raw: value
			}
		},
		monthCount() {
			// format YYYYMM
			if(! this.report) {
				return 0
			}
			const from = moment(this.report.from, 'YYYYMM')
			const to = moment(this.report.to, 'YYYYMM')
			return to.diff(from, 'months') + 1
		}
	}
}
</script>
<style scoped>
.bill-audit-report-page {
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #ccc;
}
th.head {
	background: #246284 !important;
	text-transform: uppercase;
	color: #fff;
}
.all-center {
	text-align: center;
	vertical-align: middle;
}
.bold {
	font-weight: bold;
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/BillAudit/Report.vue